import { ActivatedRoute } from '@angular/router';
import { BaseUpdateComponent, BaseDataService, QueryParameter, ModalService, BaseCommonComponent, UserService, NotificationService } from 'yt-ng-framework';
import { Component, OnInit } from "@angular/core";
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { OrgJed } from 'src/app/lookups/orgjed/orgjed';
// import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'yt-rekapitulacija-troskova',
    templateUrl: './rekapitulacija-troskova.component.html'
})

export class RekapitulacijaTroskovaComponent 
extends BaseCommonComponent
implements OnInit {

    constructor(
        protected activatedRoute: ActivatedRoute,
        protected baseDataService: BaseDataService,
        // protected notificationService: NotificationsService,
        protected toastrService: NotificationService,
        protected translateService: TranslateService,
        protected userService: UserService,
        protected modalService: ModalService
    ) {
        super(activatedRoute, userService, baseDataService, translateService, modalService,toastrService);
    }

    // Proveriti samo šta ovde treba da stoji za ID, zavisi od SP koja se poziva za izvšetaj...
    source = [
        { ID: 'komitent_id', Name: 'Komitent' },
        { ID: 'vrsta_troska_id', Name: 'Vrsta troška' },
        { ID: 'org_jed_id', Name: 'Organizaciona jedinica' }      
    ]

    // deklaracija promenljive
    AnaSinOP

    //ova metoda postoji na HTMLu, reaguje na promenu stavki u kaskadnom dorpdown-u
    SortByItemSelected(item)
    {
    var ElemntiBroj = item.split(',').length;
    if (ElemntiBroj <= 2)
        {
        this.baseFormGroup.get('AnaSin').disable();
        this.baseFormGroup.get('AnaSin').patchValue(null);
        }  
        else
        {
        this.baseFormGroup.get('AnaSin').enable();
        }
    } 

    //ako postoji samo jedna organizaciona jedinica onda da na MultiSelectu bude čekirana ta jedna org.jed.
    SkupiOrgJed(items)
     {
          if (items && items.length == 1)
       {
            this.baseFormGroup.patchValue({OrgJedIDS : items[0].ID});
            this.baseFormGroup.get('OrgJedIDS').updateValueAndValidity();
          }
    };

    ngOnInit() {
        super.ngOnInit();

         this.SkupiOrgJed(this.items); 
  
         this.AnaSinOP = [
            {ID: 0, Name: 'Sintetički'},
            {ID: 1, Name: 'Analitički'},   
            ]

        let dateNow = new Date();        
        this.baseFormGroup = new FormGroup({
            OdDatuma: new FormControl(new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, 1), [Validators.required]),
            DoDatuma: new FormControl(new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate()), [Validators.required]),
            OrgJedIDS: new FormControl(null, [Validators.required]),
            KomitentID: new FormControl(null,[Validators.required]),
            VrstaTroska: new FormControl(null, [Validators.required]),                    
            SortBy: new FormControl(),
            AnaSin: new FormControl(null)
           // SortByName: new FormControl()
        })     
                     
        this.addValidatorToFc("OdDatuma",Validators.required, 'required', 'REKAPITULACIJATROSKOVA.ODDATUMA.VALIDATION.REQUIRED');
        this.addValidatorToFc("DoDatuma",Validators.required, 'required', 'REKAPITULACIJATROSKOVA.DODATUMA.VALIDATION.REQUIRED');
        this.addValidatorToFc("OrgJedIDS",Validators.required, 'required','REKAPITULACIJATROSKOVA.ORGJED.VALIDATION.REQUIRED');
        this.addValidatorToFc("KomitentID",Validators.required, 'required','REKAPITULACIJATROSKOVA.KOMITENTNAZIV.VALIDATION.REQUIRED');        
        this.addValidatorToFc("VrstaTroska",Validators.required, 'required','REKAPITULACIJATROSKOVA.VRSTATROSKA.VALIDATION.REQUIRED');         
        this.addValidatorToFc("SortBy",Validators.required, 'required','REKAPITULACIJATROSKOVA.SORTIRANJE.VALIDATION.REQUIRED');
        this.addValidatorToFc("AnaSin",Validators.required, 'required','REKAPITULACIJATROSKOVA.ANASIN.VALIDATION.REQUIRED');
        }
   
}
